const de = {
  push: 'Neuer Empfänger',
  check: 'Erstellen',
  cancel: 'Abbrechen',
  email: 'Email',
}
export default de;